import { createReducer, on } from '@ngrx/store';
import * as SummaryActions from './summary.actions';

export interface State {

}

export const initialState: State = {

};


export const summaryReducer = createReducer(
  initialState,

  on(SummaryActions.loadVirtualEventSummary, state => state),
  on(SummaryActions.loadVirtualEventSummarySuccess, (state, action) => {
    return {
      ...state,
      ...action.data
    };
  }),
  on(SummaryActions.loadVirtualEventSummaryFailure, (state) => state),

  on(SummaryActions.updateVirtualEventSummary, (state, action) => {
    return {
      ...state,
      ...action.payload
    };
  }),

  on(SummaryActions.clearVirtualEventSummary, (state) => [])

);

export function reducer(state, action) {
  return summaryReducer(state, action);
}